import { render, staticRenderFns } from "./ElderlyInsCheckIn.vue?vue&type=template&id=5c7c36e5&scoped=true&"
import script from "./ElderlyInsCheckIn.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsCheckIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c36e5",
  null
  
)

export default component.exports